import * as moment from "moment";
import { TallyConfig } from "../helpers/constants";
import { xmlToJs } from "../helpers/xmltojs";
import axios from "axios";
import { findAllByTestId } from "@testing-library/react";
import { xmlFormatter } from "../helpers/xmlFormatter";


export async function CreateInvoice({ order, salesAccount, taxAccount, godown, company, voucherType, isOptional }) {

    let dealer = order?.dealer || {}
    let stateName = dealer?.state || ""

    if (!voucherType && voucherType === "") {
        voucherType = "Sales"
    } else {
        voucherType = voucherType?._attributes?.NAME
    }

    let tallyCompanyList = JSON.parse(window.localStorage.getItem("tally-company-list"))
    let tallyCompanyInfo = tallyCompanyList[company]

    stateName = stateName.replace("-", " ")
    // capitalize first letter of each word
    stateName = stateName.replace(/\b\w/g, l => l.toUpperCase())

    let currentState = tallyCompanyInfo?.state || ""
    currentState = currentState.replace("-", " ")
    currentState = currentState.replace(/\b\w/g, l => l.toUpperCase())

    let date = order?.createdAt
    // date as 20240401 format
    date = moment(date).format("YYYYMMDD")

    let _priceLevel = order?.tallySalesVoucherDetails?.priceLevel || ""

    let addressList = order?.shippingAddress?.addressL1.split(",")
    let shippingAddress = []

    if (order?.shippingAddress?.area !== "" && order?.shippingAddress?.city !== "") {
        // split addressL1 in to three parts
        let lengthOfAddressList = addressList.length
        let partSize = Math.floor(lengthOfAddressList / 3)

        if (partSize === 0) {
            shippingAddress = [...addressList, order?.shippingAddress?.area + ", " + order?.shippingAddress?.city]
        } else {
            let part1 = addressList.slice(0, partSize).join(", ")
            let part2 = addressList.slice(partSize, partSize * 2).join(", ")
            let part3 = addressList.slice(partSize * 2, lengthOfAddressList).join(", ")

            shippingAddress = [part1, part2, part3, order?.shippingAddress?.area + ", " + order?.shippingAddress?.city]
        }
    } else {
        // split addressL1 in to four parts
        let lengthOfAddressList = addressList.length
        let partSize = Math.floor(lengthOfAddressList / 4)

        if (partSize === 0) {
            shippingAddress = [...addressList]
        } else {

            let part1 = addressList.slice(0, partSize).join(", ")
            let part2 = addressList.slice(partSize, partSize * 2).join(", ")
            let part3 = addressList.slice(partSize * 2, partSize * 3).join(", ")
            let part4 = addressList.slice(partSize * 3, lengthOfAddressList).join(", ")

            shippingAddress = [part1, part2, part3, part4]
        }
    }

    let billingAddressList = order?.billingAddress?.addressL1.split(",")
    let billingAddress = []

    if (order?.billingAddress?.area !== "" && order?.billingAddress?.city !== "" && order?.billingAddress?.addressL1 !== "") {
        billingAddress = shippingAddress
    } else {

        if (order?.billingAddress?.area !== "" && order?.billingAddress?.city !== "") {
            // split addressL1 in to three parts
            let lengthOfAddressList = billingAddressList.length
            let partSize = Math.floor(lengthOfAddressList / 3)

            if (partSize === 0) {
                billingAddress = [...billingAddressList, order?.billingAddress?.area + ", " + order?.billingAddress?.city]
            } else {

                let part1 = billingAddressList.slice(0, partSize).join(", ")
                let part2 = billingAddressList.slice(partSize, partSize * 2).join(", ")
                let part3 = billingAddressList.slice(partSize * 2, lengthOfAddressList).join(", ")

                billingAddress = [part1, part2, part3, order?.billingAddress?.area + ", " + order?.billingAddress?.city]
            }
        } else {
            // split addressL1 in to four parts
            let lengthOfAddressList = billingAddressList.length
            let partSize = Math.floor(lengthOfAddressList / 4)

            if (partSize === 0) {
                billingAddress = [...billingAddressList]
            } else {

                let part1 = billingAddressList.slice(0, partSize).join(", ")
                let part2 = billingAddressList.slice(partSize, partSize * 2).join(", ")
                let part3 = billingAddressList.slice(partSize * 2, partSize * 3).join(", ")
                let part4 = billingAddressList.slice(partSize * 3, lengthOfAddressList).join(", ")

                billingAddress = [part1, part2, part3, part4]
            }
        }

    }

    console.log(order)
    // let stockItems = JSON.parse(window.localStorage.getItem(`tally-${TallyConfig.company}-stock-items`))

    // if (!stockItems) {
    //     return false
    // }

    // stockItems = stockItems?.ENVELOPE?.BODY?.DATA?.COLLECTION?.STOCKITEM || []
    // if (!(stockItems instanceof Array)){
    //     stockItems = [stockItems]
    // }

    // let tallyProductMap = {}

    // stockItems.forEach(stockItem => {
    //     let Masterid = stockItem?.MASTERID?._text
    //     tallyProductMap[Masterid] = stockItem
    // })

    let amount = 0
    for (let i = 0; i < order?.orderItems?.length; i++) {
        let item = order?.orderItems[i]
        let temp = (item?.price * item?.quantity * ((100 - (item?.discount || 0)) / 100))
        temp = parseFloat(parseFloat(temp).toFixed(2))

        amount += temp
        order.orderItems[i].tallyId = order?.products[item?.productId]?.tallyId
    }

    amount = parseFloat(parseFloat(amount).toFixed(2))
    let subTotal = amount


    for (let i = 0; i < taxAccount?.length; i++) {
        let tax = taxAccount[i]

        let taxRate = tax?.RATEOFTAXCALCULATION?._text

        taxRate = parseFloat(taxRate)

        let taxAmount = (subTotal * taxRate) / 100

        let taxOnProducts = 0

        for (let k = 0; k < order?.orderItems?.length; k++) {
            let item = order?.orderItems[k]
            let product = order?.products[item?.productId]

            let taxRates = product?.taxRates

            if (!taxRates) {
                continue
            }

            let gstHead = tax?.GSTDUTYHEAD?._text?.trim() || ""

            if (gstHead === "") {
                continue
            }

            let taxRate = taxRates[gstHead]

            if (!taxRate) {
                continue
            }

            let _amount = (item?.price * item?.quantity * ((100 - (item?.discount || 0)) / 100))
            _amount = parseFloat(parseFloat(_amount).toFixed(2))

            taxOnProducts += (_amount * taxRate) / 100
        }

        if (taxOnProducts !== 0) {
            taxAmount = taxOnProducts
        }

        taxAmount = parseFloat(parseFloat(taxAmount).toFixed(2))
        amount += taxAmount
        amount = parseFloat(parseFloat(amount).toFixed(2))
    }

    const makeInventoryEntry = (item) => {

        let product = order?.products[item?.productId]

        return `

            <ALLINVENTORYENTRIES.LIST>
                <STOCKITEMNAME>${product?.name}</STOCKITEMNAME>
                <ISDEEMEDPOSITIVE>No</ISDEEMEDPOSITIVE>
                <ISLASTDEEMEDPOSITIVE>No</ISLASTDEEMEDPOSITIVE>
                <RATE>${parseFloat(item?.price).toFixed(2)}/${product?.tallyVatBaseUnit}</RATE>
                <AMOUNT>${parseFloat((item?.price * item?.quantity * ((100 - (item?.discount || 0)) / 100))).toFixed(2)}</AMOUNT>
                <ACTUALQTY>${item?.quantity} ${product?.tallyVatBaseUnit}</ACTUALQTY>
                <BILLEDQTY>${item?.quantity} ${product?.tallyVatBaseUnit}</BILLEDQTY>
                <DISCOUNT>${item?.discount || 0}</DISCOUNT>
                
                <BATCHALLOCATIONS.LIST>
                    <GODOWNNAME>${godown?.name}</GODOWNNAME>
                    <AMOUNT>${parseFloat((item?.price * item?.quantity * ((100 - (item?.discount || 0)) / 100))).toFixed(2)}</AMOUNT>
                    <ACTUALQTY>${item?.quantity} ${product?.tallyVatBaseUnit}</ACTUALQTY>
                    <BILLEDQTY>${item?.quantity} ${product?.tallyVatBaseUnit}</BILLEDQTY>
                    <INCLVATRATE/>
                </BATCHALLOCATIONS.LIST>
                <ACCOUNTINGALLOCATIONS.LIST>
                    <LEDGERNAME>${salesAccount?._attributes?.NAME}</LEDGERNAME>
                    <ISDEEMEDPOSITIVE>No</ISDEEMEDPOSITIVE>
                    <ISLASTDEEMEDPOSITIVE>No</ISLASTDEEMEDPOSITIVE>
                    <AMOUNT>${parseFloat((item?.price * item?.quantity * ((100 - (item?.discount || 0)) / 100))).toFixed(2)}</AMOUNT>
                    <ISPARTYLEDGER>No</ISPARTYLEDGER>
                </ACCOUNTINGALLOCATIONS.LIST>
            </ALLINVENTORYENTRIES.LIST>
        `   
    }

    const makeTaxLedgerEntry = (tax) => {

        let taxRate = tax?.RATEOFTAXCALCULATION?._text
        taxRate = parseFloat(taxRate)
        let taxAmount = (subTotal * taxRate) / 100

        let taxOnProducts = 0

        for (let k = 0; k < order?.orderItems?.length; k++) {
            let item = order?.orderItems[k]
            let product = order?.products[item?.productId]

            let taxRates = product?.taxRates

            if (!taxRates) {
                continue
            }

            let gstHead = tax?.GSTDUTYHEAD?._text?.trim() || ""

            if (gstHead === "") {
                continue
            }

            let taxRate = taxRates[gstHead]

            if (!taxRate) {
                continue
            }

            let _amount = (item?.price * item?.quantity * ((100 - (item?.discount || 0)) / 100))
            _amount = parseFloat(parseFloat(_amount).toFixed(2))

            taxOnProducts += (_amount * taxRate) / 100
        }

        if (taxOnProducts !== 0) {
            taxAmount = taxOnProducts
            taxRate = 0
        }

        return `
            <LEDGERENTRIES.LIST>
                <LEDGERNAME>${tax?._attributes?.NAME}</LEDGERNAME>
                ${taxRate ? `<RATEOFINVOICETAX.LIST TYPE="Number">
                    <RATEOFINVOICETAX>${tax?.RATEOFTAXCALCULATION?._text}</RATEOFINVOICETAX>
                </RATEOFINVOICETAX.LIST>` : ''}
                <ISDEEMEDPOSITIVE>No</ISDEEMEDPOSITIVE>
                <ISPARTYLEDGER>No</ISPARTYLEDGER>
                <AMOUNT>${parseFloat(taxAmount).toFixed(2)}</AMOUNT>
                <VATEXPAMOUNT>${parseFloat(taxAmount).toFixed(2)}</VATEXPAMOUNT>
            </LEDGERENTRIES.LIST>    
        `
    }

    let data = `
    <ENVELOPE>
        <HEADER>
            <VERSION>1</VERSION>
            <TALLYREQUEST>Import</TALLYREQUEST>
            <TYPE>Data</TYPE>
            <ID>Vouchers</ID>
        </HEADER>
        <BODY>
            <DESC>
                <STATICVARIABLES>
                    <SVCURRENTCOMPANY>${company !== "" ? company : TallyConfig.company}</SVCURRENTCOMPANY>
                </STATICVARIABLES>
            </DESC>
            <DATA>
                <TALLYMESSAGE>
                    <VOUCHER>
                        <DATE>${date}</DATE>
                        <ISINVOICE>Yes</ISINVOICE>
                        <ISOPTIONAL>${isOptional}</ISOPTIONAL>
                        <PERSISTEDVIEW>Invoice Voucher View</PERSISTEDVIEW>
                        ${shippingAddress?.length > 0 && `<ADDRESS.LIST TYPE="String">
                            ${shippingAddress.map((address) => {
                                return `<ADDRESS>${address}</ADDRESS>`
                            }).join("\n")}
                        </ADDRESS.LIST>`}
                        ${billingAddress?.length > 0 && `<BASICBUYERADDRESS.LIST TYPE="String">
                            ${billingAddress.map((address) => {
                                return `<BASICBUYERADDRESS>${address}</BASICBUYERADDRESS>`
                            }).join("\n")}
                        </BASICBUYERADDRESS.LIST>`}
                        <PARTYNAME>${dealer?.name}</PARTYNAME>
                        <VOUCHERTYPENAME>${voucherType}</VOUCHERTYPENAME>
                        <PARTYLEDGERNAME>${dealer?.name}</PARTYLEDGERNAME>
                        <BASICBUYERNAME>${dealer?.name}</BASICBUYERNAME>
                        ${dealer?.gstin ? `<PARTYGSTIN>${dealer?.gstin}</PARTYGSTIN>` : ``}
                        <STATENAME>${stateName}</STATENAME>
                        <CMPGSTSTATE>${currentState}</CMPGSTSTATE>
                        <COUNTRYOFRESIDENCE>India</COUNTRYOFRESIDENCE>
                        <PLACEOFSUPPLY>${stateName}</PLACEOFSUPPLY>
                        ${dealer?.pincode ? `<PARTYPINCODE>${dealer?.pincode}</PARTYPINCODE>` : ``}
                        ${dealer?.gstin ? `<CONSIGNEEGSTIN>${dealer?.gstin}</CONSIGNEEGSTIN>` : ``}
                        <CONSIGNEESTATENAME>${stateName}</CONSIGNEESTATENAME>
                        <CONSIGNEEPINCODE>${dealer?.pincode}</CONSIGNEEPINCODE>
                        ${_priceLevel != "" ? `<PRICELEVEL>${_priceLevel}</PRICELEVEL>` : ``}
                        ${(order?.note && order?.note!=="") ? `<NARRATION>${order?.note}</NARRATION>` : ``}
                        <LEDGERENTRIES.LIST>
                            <LEDGERNAME>${dealer?.name}</LEDGERNAME>
                            <AMOUNT>-${parseFloat(amount).toFixed(2)}</AMOUNT>
                            <ISDEEMEDPOSITIVE>Yes</ISDEEMEDPOSITIVE>
                            <ISLASTDEEMEDPOSITIVE>Yes</ISLASTDEEMEDPOSITIVE>
                            <ISPARTYLEDGER>Yes</ISPARTYLEDGER>
                        </LEDGERENTRIES.LIST>
                        ${(taxAccount?.length > 0) ? taxAccount?.map((tax, index) => {
                            return makeTaxLedgerEntry(tax)
                        }).join("") : ``}   

                        ${order?.orderItems?.length && order?.orderItems?.map((item, index) => {
                            return makeInventoryEntry(item)
                        }).join("")}
                    </VOUCHER>
                </TALLYMESSAGE>
            </DATA>
        </BODY>
    </ENVELOPE>

    
    `

    
    data = xmlFormatter(data)
    console.log(data)

    try {
        let resp = await window.electron.tallyConnect({
            url: `${TallyConfig.host}:${TallyConfig.port}`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml',
            },
            timeout: 500000,
            data: data
        })

        if (resp.status === 200) {
            let jsonData = resp?.data

            if (jsonData?.ENVELOPE?.BODY?.DATA?.IMPORTRESULT?.CREATED?._text === "1") {
                let voucherId = jsonData?.ENVELOPE?.BODY?.DATA?.IMPORTRESULT?.LASTVCHID?._text
                return voucherId
            } else {
                console.log(jsonData)
                return false
            }
        } else {
            return false
        }
    } catch (err) {
        console.log(err)
        return false
    }
}